/**
 * Import theme scripts
 *
 * Compiles to ./dist/assets/scripts/layout.theme.js
 */

/* eslint-disable no-unused-vars */

// Import ES6 modules (recommended)

